import React from 'react';
import VendorSpecialitiesPanel from './VendorSpecialitiesPanel';
import VendorSyncPanel from './VendorSyncPanel';

/** /admin/vendors: specialities and their access, then the vendor sync and Odoo check. */
export default function AdminVendorsTab() {
  return (
    <div className="vd-admin">
      <VendorSpecialitiesPanel />
      {/* Short status panels in a rail that stays in view beside the long tag table. */}
      <aside className="vd-admin-rail" aria-label="Vendor sync and Odoo check">
        <VendorSyncPanel />
      </aside>
    </div>
  );
}
